import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function HireClippersSuccess() {
  const { t } = useTranslation();

  return (
    <Card data-testid="hire-clippers-success">
      <CardContent className="flex flex-col items-center gap-4 p-8 text-center sm:p-10">
        <span className="grid h-12 w-12 place-items-center rounded-2xl border border-primary/30 bg-primary/15">
          <Check aria-hidden="true" className="h-6 w-6 text-primary" />
        </span>
        <h2 className="text-2xl font-semibold">{t('hireClippers.success.title')}</h2>
        <p className="max-w-md text-muted-foreground">
          {t('hireClippers.success.description')}
        </p>
        <Button asChild>
          <Link to="/projects">{t('hireClippers.success.cta')}</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
